import React, { useEffect } from 'react';

const REPOSITORY_URL = 'https://github.com/Lasdw6/Abra';

const Abra: React.FC = () => {
  useEffect(() => {
    window.location.replace(REPOSITORY_URL);
  }, []);

  return (
    <main className="pt-24 px-6 text-center text-minimal-grey">
      <p>Opening Abra on GitHub…</p>
      <a href={REPOSITORY_URL} className="text-minimal-red underline">
        Go to the Abra repository
      </a>
    </main>
  );
};

export default Abra;
